import { z } from 'zod';
import { revenueCatProduct } from './RevenueCatProduct';

export const revenueCatPackage = z.object({
  object: z.literal('package'),
  id: z.string(),
  lookup_key: z.string(),
  display_name: z.string(),
  position: z.number().nullish(),
  created_at: z.number(),
  products: z.object({
    object: z.literal('list'),
    items: z.array(
      z.object({
        product: revenueCatProduct,
        eligibility_criteria: z.string(),
      }),
    ),
    next_page: z.string().nullish(),
    url: z.string(),
  }),
});

export type RevenueCatPackage = z.infer<typeof revenueCatPackage>;
